import { render, staticRenderFns } from "./YoutubeToTweet.vue?vue&type=template&id=07825d12&scoped=true&"
import script from "./YoutubeToTweet.vue?vue&type=script&lang=js&"
export * from "./YoutubeToTweet.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeToTweet.vue?vue&type=style&index=0&id=07825d12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07825d12",
  null
  
)

export default component.exports